import styled from 'styled-components'
import * as React from 'react'
import { Checkbox } from '@webnuts/university-greenland-shared-components'
import { Column, Placement, Row, Space } from '@webnuts/shared-components'

const Container = styled.div`
  height: 45px; // todo: this should be a variable
`

type CenteredCheckboxProps = {
  hint: string
}

type Props = CenteredCheckboxProps & React.ComponentProps<typeof Checkbox>

class CenteredCheckbox extends React.Component<Props> {
  render() {
    return (
      <Container>
        <Placement vertical={'center'}>
          <Space marginRight={15}>
            <Checkbox {...this.props} />
          </Space>
          {this.props.hint}
        </Placement>
      </Container>
    )
  }
}

export default CenteredCheckbox
